import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import { activeNetworkSelector, userSelector } from '../../redux/selectors';

const getAnonDeviceId = () => {
  let id = sessionStorage.getItem('amplitude_device_id');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('amplitude_device_id', id);
  }
  return id;
};

const integrations = {
  track: (event, properties) => {
    amplitude.track(event, properties);
  },
};

export const useEngagement = () => {
  const routerHistory = useHistory();
  const activeNetwork = useSelector(activeNetworkSelector);
  const user = useSelector(userSelector);
  const { pathname } = useLocation();

  const routerFunc = (newUrl) => routerHistory.push(newUrl);

  useEffect(() => {
    window.engagement?.boot({ user: { device_id: getAnonDeviceId() }, integrations })?.catch(() => {});
    window.engagement?.setRouter(routerFunc);

    return () => {
      window.engagement?.shutdown();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (user.id) {
      amplitude.setUserId(`${user.id}`);
      window.engagement?.boot({ user: { user_id: `${user.id}` }, integrations })?.catch(() => {});
    }
  }, [user.id]);

  useEffect(() => {
    if (activeNetwork && pathname.startsWith(`/networks/${activeNetwork.slug}`)) {
      window.engagement?.setSessionProperty('currentNetworkSlug', activeNetwork.slug);
      window.engagement?.setSessionProperty('currentNetworkName', activeNetwork.name);
      window.engagement?.setSessionProperty('hasMatches', activeNetwork.isManager);
    }
  }, [activeNetwork, pathname]);
};
